// src/components/Footer/Footer.jsx
import React from 'react';
import './Footer.css';
import logoImg from '../../assets/Logo2.png';

const Footer = () => {
  return (
    <footer className="footer-section text-white overflow-hidden">
      <div className="container py-4 px-lg-5">

        {/* --- ROW 1: Logo & Contact Info --- */}
        <div className="footer-header-section my-5">
          <div className="d-flex align-items-center gap-4 flex-wrap flex-md-nowrap">
            {/* Left Column: Logo */}
            <div className="footer-logo-container">
              <a href="/" className="footer-logo-link">
                <img src={logoImg} alt="Dynamic Stamping" className="footer-logo" />
              </a>
            </div>

            {/* Right Column: All Info (Address, Email, Phone) */}
            <div className="footer-info-column d-flex flex-column gap-4">
              <p className="text-white mb-0 small single-line-address">
                NO : 99, SURVEY NO.561 / 1C-2, PAPPARAMBAKKAM VILLAGE, THIRUVALLUR (TALUK & DISTRICT )– 602 025, TAMIL NADU, INDIA
              </p>

              <div className="d-flex flex-column gap-1">
                <a href="mailto:shanmugaperumal@dynamic-stamping.com" className="text-white text-decoration-none small">
                  shanmugaperumal@dynamic-stamping.com
                </a>
                <a href="tel:+919840314831" className="text-white text-decoration-none fw-bold small">
                  +91 98403 14831
                </a>
              </div>
            </div>
          </div>
        </div>


        {/* --- ROW 3: Bottom Copyright --- */}
        <div className="border-top border-white-10 pt-4">
          <div className="row align-items-center small text-white-50">
            <div className="col-md-6 text-center text-md-start mb-2 mb-md-0">
              &copy; 2025 Dynamic Stamping Pvt. Ltd. All rights reserved.
            </div>

            <div className="col-md-6 text-center text-md-end">
              <a href="/" className="text-white-50 text-decoration-none me-3">Terms and conditions</a> |
              <a href="/" className="text-white-50 text-decoration-none ms-3">Privacy Policy</a>
            </div>
          </div>
        </div>

      </div>
    </footer>
  );
};

export default Footer;